/* ==========================================================================
   VITAPOP - FOUNDATION MOTION LAYER  (vp-spec-v1.js, 2026-07-03)
   Subtle, luxurious, reduced-motion-safe scroll reveals for the spec build.
   - Fade-up on scroll (translateY 16px -> 0 + opacity), 60ms stagger, IO @ 15%.
   - Opt-in hooks: any element with class .vp-fade-up or [data-vp-fade].
   - Auto-applies a curated, non-destructive reveal to homepage section content
     (headings / leads / cards / grids), SKIPPING the collagen-journey timeline
     which already owns its own scroll animation in vp-home-v5.js.
   - Fail-safe: the hiding class is only added when motion is allowed; a fallback
     timer reveals everything after 1200ms so nothing can be left invisible.
   Revert: remove the vp-spec-v1.js tag from layout/theme.liquid (DRAFT only).
   ========================================================================== */
(function () {
  if (window.__vpSpecMotion) return;           /* idempotent */
  window.__vpSpecMotion = true;

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    if (reduce) return;                          /* respect the user - no motion, no hiding */

    var targets = [];

    /* explicit opt-in hooks */
    Array.prototype.push.apply(targets, document.querySelectorAll('.vp-fade-up, [data-vp-fade]'));

    /* curated auto-reveal on the homepage brand sections only */
    if (document.body && document.querySelector('.vp-hero6, .vp-promise6, .vp-benefits, .v5-benefits')) {
      var sel = [
        '.vp-promise6__inner',
        '.vp-why6__copy', '.vp-why6__quote',
        '.v5-benefits .v5-center', '.v5-bcard',
        '.vp-social6 .v5-center',
        '.vp-reviews6__head', '.vp-reviews6__foot',
        '.vp-closer6 .v5-center > *'
      ].join(',');
      document.querySelectorAll(sel).forEach(function (n) {
        /* never touch the journey timeline (owns its own animation) */
        if (n.closest && n.closest('.v5-journey')) return;
        targets.push(n);
      });
    }

    /* de-dupe */
    targets = targets.filter(function (n, i, a) { return n && a.indexOf(n) === i; });
    if (!targets.length) return;

    var reveal = function (n, i) {
      n.classList.add('vp-fade-up');
      if (i != null) n.style.transitionDelay = (Math.min(i, 6) * 60) + 'ms';
    };

    if (!('IntersectionObserver' in window)) {
      /* no IO support -> just show everything, no motion */
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('vp-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (n, i) {
      /* if it's already in view on load, reveal without hiding-flash */
      var r = n.getBoundingClientRect();
      var inView = r.top < (window.innerHeight * 0.92) && r.bottom > 0;
      reveal(n, i);
      if (inView) { requestAnimationFrame(function () { n.classList.add('vp-in'); }); }
      else io.observe(n);
    });

    /* absolute fail-safe: nothing stays hidden */
    setTimeout(function () {
      targets.forEach(function (n) { n.classList.add('vp-in'); });
    }, 1200);
  });
})();
